<template>
  <div class="container">
    <div class="order">
      <div
        class="orders"
        v-for="(item, index) in expressInfo.order && expressInfo.order.cartInfo"
        :key="index"
      >
        <img :src="item.productInfo.image" />
        <div class="name">{{ item.productInfo.store_name }}</div>
        <div class="number">
          <div>￥{{ item.truePrice }}</div>
          <div>×{{ item.cart_num }}</div>
        </div>
      </div>
    </div>
    <div class="express">
      <div class="info">
        <img :src="expressInfo.express && expressInfo.express.result.logo" />
        <div class="detail">
          <div class="name">
            快遞公司：<span class="value">{{
              expressInfo.express && expressInfo.express.result.expName
            }}</span>
          </div>
          <div class="name">
            快遞單號：<span class="value">{{
              expressInfo.express && expressInfo.express.result.number
            }}</span>
          </div>
        </div>
        <div
          class="copy"
          v-clipboard:error="onError"
          v-clipboard:copy="
            expressInfo.express && expressInfo.express.result.number
          "
          v-clipboard:success="onSuccess"
        >
          複製單號
        </div>
      </div>
      <div class="progress">
        <div
          class="item"
          v-for="(item, index) in expressInfo.express &&
            expressInfo.express.result.list"
          :key="index"
        >
          <div class="circle" :class="index === 0 ? 'on' : ''"></div>
          <div class="status" :class="index === 0 ? 'on2' : ''">
            {{ item.status }}
          </div>
          <div class="time">{{ item.time }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { express } from "@/api/order";
export default {
  name: "expressInfo",
  data() {
    return {
      expressInfo: {}
    };
  },
  mounted() {
    this.getExpressInfo();
  },
  methods: {
    async getExpressInfo() {
      let exp = await express(this.$route.params.id);
      this.expressInfo = exp.data;
    },
    onError() {
      this.$Message.error("複製失敗");
    },
    onSuccess() {
      this.$Message.success("複製成功");
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  padding-bottom :100px
  .order
    border-bottom :8px rgb(245,245,245) solid
    .orders
      display :flex
      align-items flex-start
      padding : 20px
      img
        width 100px
        height 100px
      .name
        flex-grow:1
        margin-left:10px
        font-size :15px
      .number
        display flex
        flex-direction :column
        align-items :flex-end
  .express
    .info
      display :flex
      align-items :center
      padding:20px
      img
        width 56px
        height 56px
      .detail
        flex-grow:1
        margin-left :10px
        .name
          color :rgb(153,153,153)
          .value
            color :#000
      .copy
        padding: 2px 4px
        border: 1px #000 solid
        cursor :pointer
  .progress
    .item
      padding : 0 20px 20px 20px
      border-left :2px rgb(245,245,245) solid
      position :relative
      .circle
        width 10px
        height 10px
        border-radius: 100px
        background-color :rgb(245,245,245)
        position :absolute
        left :-5px
        top :0
        z-index: 99
      .on
        background-color:rgb(233,51,35)
      .on2
        color:rgb(252,65,65)
      .status
        font-size :15px
      .time
        font-size :10px
        color :rgb(166,153,179)
</style>
